import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const loginSlice = createSlice({
  name: "loginSlice",
  initialState: {
    loginRequestData: {},
    ssologinRequestData: {},
    systemSettingsData: {},
    errorMessage: undefined,
    dataFetchingStatus: false,
    isLoggedIn: false,
  },

  reducers: {
    setLoginRequestData: (state, action) => {
      state.loginRequestData = action.payload;
    },
    setSSOLoginRequestData: (state, action) => {
      state.ssologinRequestData = action.payload;
    },
    setSystemSettingsDetails: (state, action) => {
      state.systemSettingsData = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
    removeElementsFromArray: (state, action) => {
      state.loginRequestData = action.payload;
    },
    setIsloggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
  },
});

export const {
  setLoginRequestData,
  setSSOLoginRequestData,
  setSystemSettingsDetails,
  setErrorMessage,
  setDataFetchingStatus,
  removeElementsFromArray,
  setIsloggedIn,
} = loginSlice.actions;

export const loginRequest = (data) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setErrorMessage(undefined));
  dispatch(setDataFetchingStatus(true));
  axios
    .post("/login", data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setLoginRequestData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data));
    });
};
export const SSOloginRequestAPI = (data) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setErrorMessage(undefined));
  dispatch(setDataFetchingStatus(true));
  axios
    .get("/ssologin", {
      params: data,
    })
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setSSOLoginRequestData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data));
    });
};

export const SystemSettingsDetails = () => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setErrorMessage(undefined));
  dispatch(setDataFetchingStatus(true));
  axios
    .get("/systemsettings")
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setSystemSettingsDetails(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data));
    });
};
export const clearLoginData = () => (dispatch) => {
  dispatch(removeElementsFromArray({}));
};
export const isLoggedInUpdate = (data) => (dispatch) => {
  dispatch(setIsloggedIn(data));
};

export default loginSlice.reducer;
